module.exports = __webpack_public_path__ + "img/about-mobile.b5608537.png";